
import { reactive, ref,inject,onMounted  } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import {Toast} from 'vant'
 
import Header from '@/components/header/header.vue'
export default {  
  components:{
    Header
  },
  setup( ){
       const $http: any = inject('$http')
    const state = reactive({
      password: '',
      newpassword: '',
      repassword: '',
    });
    const isShowOldPassword = ref(false);
    const isShowNewPassword = ref(false);
    const isShowConPassword = ref(false);
   
 const submit = async function () {
        if(!state.password){
          return Toast("Please Enter your Current Password.")
      }
        if(!state.newpassword){
          return Toast("Please Enter your new password.")
      }
      if(state.newpassword.length < 6) {
          return Toast("New password minimum 6 characters required.")
      }
      if(!state.repassword){
          return Toast("Please enter your confirmation password.")
      }
      if(state.repassword != state.newpassword){
          return Toast("Confirmed password is not corrected.")
      }
       let ret = await $http.modifyPassword(state);  
       if(ret.code == 200) {
         Toast(ret.message)
         setTimeout(() => {
           window.history.go(-1)
         },2000)
       } else {
         Toast(ret.message)

       }
        }
    return { state,submit,isShowConPassword,isShowNewPassword,isShowOldPassword };
  }
} 
